import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { fg } from '@atlaskit/platform-feature-flags';
import { startLighthouseObserver } from '../additional-payload';
import { setUFOConfig } from '../config';
import { experimentalVC, sinkExperimentalHandler } from '../create-experimental-interaction-metrics-payload';
import { setupHiddenTimingCapture } from '../hidden-timing';
import { postInteractionLog, sinkInteractionHandler, sinkPostInteractionLogHandler } from '../interaction-metrics';
import { withProfiling } from '../self-measurements';
import { getVCObserver } from '../vc';
import scheduleIdleCallback from './schedule-idle-callback';
var initialized = false;
var sinkInteraction = withProfiling(function sinkInteraction(instance, payloadPackage) {
  var sinkFn = withProfiling(function sinkFn(interactionId, interaction) {
    var onIdle = withProfiling(function onIdle() {
      payloadPackage.createPayloads(interactionId, interaction).then(function (payloads) {
        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
        var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
        payloads === null || payloads === void 0 || payloads.forEach(function (payload) {
          if (typeof devToolObserver === 'function') {
            devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
          }
          instance.sendOperationalEvent(payload);
        });
      }).catch(function (error) {
        throw error;
      });
    });
    scheduleIdleCallback(onIdle);
  });
  sinkInteractionHandler(sinkFn);
});
var sinkExperimentalInteractionMetrics = withProfiling(function sinkExperimentalInteractionMetrics(instance, payloadPackage) {
  var experimentalMetricsSinkFn = withProfiling(function experimentalMetricsSinkFn(interactionId, interaction) {
    var experimentalMetricsOnIdle = withProfiling(function experimentalMetricsOnIdle() {
      var payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
      payloadPromise.then(function (payload) {
        if (payload) {
          // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
          if (fg('enable_ufo_devtools_api_for_extra_events')) {
            // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
            var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
            if (typeof devToolObserver === 'function') {
              devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
            }
          }
          instance.sendOperationalEvent(payload);
        }
      });
    });
    scheduleIdleCallback(experimentalMetricsOnIdle);
  });
  sinkExperimentalHandler(experimentalMetricsSinkFn);
});
function sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
  sinkPostInteractionLogHandler(function (logOutput) {
    scheduleIdleCallback(function () {
      var payload = createPostInteractionLogPayload(logOutput);
      if (payload) {
        // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if (fg('enable_ufo_devtools_api_for_extra_events')) {
          var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
          if (typeof devToolObserver === 'function') {
            devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
          }
        }
        instance.sendOperationalEvent(payload);
      }
    });
  });
}
export var init = withProfiling(function init(analyticsWebClientAsync, config) {
  var _config$vc;
  if (initialized) {
    return;
  }
  setUFOConfig(config);
  if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
    var _config$experimentalI;
    var vcOptions = {
      heatmapSize: config.vc.heatmapSize,
      oldDomUpdates: config.vc.oldDomUpdates,
      devToolsEnabled: config.vc.devToolsEnabled,
      selectorConfig: config.vc.selectorConfig
    };
    getVCObserver(vcOptions).start({
      startTime: 0
    });
    postInteractionLog.initializeVCObserver(vcOptions);
    postInteractionLog.startVCObserver({
      startTime: 0
    });
    if (config !== null && config !== void 0 && (_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) {
      experimentalVC.initialize(vcOptions).start({
        startTime: 0
      });
    }
  }
  setupHiddenTimingCapture();
  startLighthouseObserver();
  initialized = true;
  Promise.all([analyticsWebClientAsync, import( /* webpackChunkName: "create-payloads" */'../create-payload'), import( /* webpackChunkName: "create-post-interaction-log-payload" */'../create-post-interaction-log-payload')]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
      awc = _ref2[0],
      payloadPackage = _ref2[1],
      createPostInteractionLogPayloadPackage = _ref2[2];
    if (awc.getAnalyticsWebClientPromise) {
      awc.getAnalyticsWebClientPromise().then(function (client) {
        var _config$experimentalI2, _config$postInteracti;
        var instance = client.getInstance();
        sinkInteraction(instance, payloadPackage);
        if (config !== null && config !== void 0 && (_config$experimentalI2 = config.experimentalInteractionMetrics) !== null && _config$experimentalI2 !== void 0 && _config$experimentalI2.enabled) {
          sinkExperimentalInteractionMetrics(instance, payloadPackage);
        }
        if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) {
          sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        }
      });
    } else if (awc.sendOperationalEvent) {
      var _config$experimentalI3, _config$postInteracti2;
      sinkInteraction(awc, payloadPackage);
      if (config !== null && config !== void 0 && (_config$experimentalI3 = config.experimentalInteractionMetrics) !== null && _config$experimentalI3 !== void 0 && _config$experimentalI3.enabled) {
        sinkExperimentalInteractionMetrics(awc, payloadPackage);
      }
      if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) {
        sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
      }
    }
  });
});